<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/link/nature'">
      <ZuiHeader />
      <SubPageTemplate page-title="自然遗产" dynamically-tab :pid="pid" type="article" :default-tab-id="defaultTabId" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter />
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";
export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      defaultTabId: ''
    }
  },
  created() {
    this.pid = this.$route.query.id || null;
        this.defaultTabId = this.$route.query.tabId || '';
        // 顶部面包屑跳转上一级目录没有参数
        if (this.$route.path == '/link/nature') {
          let obj = {
                pid: this.pid,
                defaultTabId: this.defaultTabId,
            };
            sessionStorage.setItem('natureParams', JSON.stringify(obj));
        }
  },
  watch:{
      $route(val,old){
         // 顶部面包屑跳转上一级目录没有参数 使用缓存
        if (this.$route.path == '/link/nature') {
            if ((!this.$route.query.id || !this.$route.query.tabId) && sessionStorage.getItem('natureParams')) {
                let obj = JSON.parse(sessionStorage.getItem('natureParams'));
                console.log(obj)
                this.pid = obj.pid;
                this.defaultTabId = obj.defaultTabId;
            }
           
        }
      }
    },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/link/nature/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/link/natureHeritage.vue